export default __webpack_public_path__ + "static/N0239-296cd967cd54593a93de72c1e03c4c86.png";